import React from 'react'
import './sectionAnalyse.css'
import { Input, Icon, message} from 'antd';
import InfiniteScroll from 'react-infinite-scroller';
import {showErrorMsg} from "../utils/commonFunc";
import {Theme_Color} from "../../config";
import png_have_on from '../imageSrc/have_on.png';
import png_have_off from '../imageSrc/have_off.png';
import png_start_on from '../imageSrc/start_on.png';
import png_start_off from '../imageSrc/start_off.png';

class SectionAPP extends React.Component {
    constructor(props) {
        super(props);
        this.highLightContent = [];
        this.pageNo = 1;
        this.hasMore = true;
        this.scrollLocation = 0;   //每次scroller的定位
        this.lastSelectFenci=null;  //上次点击的分词
        this.fenciMode='start';  //1。任意模式 2。追踪模式
        this.currentFenci = null; ///当前的分词
        this.state = {
            recover:false,
            startBtnPng: png_start_on,
            haveBtnPng: png_have_off,
        }
    }

    componentDidMount(){
        this.props.triggerRef(this);
        // window.addEventListener('scroll', this.bindScroll)
    }

    bindScroll = (e)  => {
        var onscroll = e.target
        // message.success(onscroll.scrollHeight)
        // message.success(this.refs.ononon.scrollHeight)
        // message.error(onscroll.scrollTop)
        // message.error(onscroll.offsetHeight)
        if (onscroll.scrollTop + onscroll.offsetHeight + 3 > onscroll.scrollHeight && this.hasMore === true) {
            this.scrollLocation = onscroll.scrollTop + onscroll.offsetHeight;
            this.handleInfiniteOnLoad();
        }
    };

    scrollToLocation = () => {
        var scroll = this.refs.scroller;
        scroll.scrollTop = this.scrollLocation;
    };

    keyworkHighLight = (content,keyword,index) => {
        // var reg = new RegExp("(" + keyword + ")","g");
        // var arrContent = content.split(keyword);
        // var ele = [];
        // arrContent.map((item,index) => {
        //     ele.push(React.createElement('span',null,item));
        //     if (index !== arrContent.length - 1) {
        //         ele.push(React.createElement('span',{style:{backgroundColor:'#688CF5'}},keyword))
        //     }
        // });
        //
        // var myDiv = React.createElement('p' , { title : 'wo shi div' } ,  ele );
        // var myContentDiv =  React.createElement('div' , { title : 'wo shi div2' } ,  myDiv );
        var changeLine = index === 0?'' : '<hr/>' +'<br/>';
        var last = document.getElementsByClassName('section_analyse_content_style')[0].innerHTML + changeLine
        this.highLightContent.push(this.searchKeywordHighlight(content,keyword));
        document.getElementsByClassName('section_analyse_content_style')[0].innerHTML = last.concat(this.searchKeywordHighlight(content,keyword,false)) ;
        if (index === this.props.arrSententce.length - 1) {
            this.scrollToLocation();
        }

    };

    searchKeywordHighlight = (content,keyword,isSearch) => {
        let arrContnet = content.split(keyword)
        var resultStr
        if (isSearch) {
            resultStr = arrContnet.join(`<span class="temp_style">${keyword}</span>`);
        } else {
            resultStr = arrContnet.join(`<span class="suggest_style">${keyword}</span>`);
        }

        return resultStr
    };

    removeContentChild = () => {
        var contentList = document.getElementsByClassName('section_analyse_content_style')[0];
        if (contentList !== undefined) {
            document.getElementsByClassName('section_analyse_content_style')[0].innerHTML = ''
        }

        // var contentList = document.getElementsByClassName('section_analyse_content_style')[0];
        // var childs = contentList.childNodes;
        // console.log(childs)
        // for(var i = 0; i < childs.length; i++) {
        //     contentList.removeChild(childs[i]);
        // }
        // console.log(childs)
    };

    removeLastHight = () => {
        this.highLightContent = [];
    };

    handleEnterKey = (event) => {
        this.removeContentChild();
        let arrSearch = [];
        let arrContent = [];
        let searchText = event.target.value;
        if (searchText.length !== 0) {
            this.highLightContent.map((item,index) => {
                if (item.indexOf(searchText) !== -1) {
                    arrSearch.push(item)
                }
            });

            var last
            arrSearch.map((item,index) => {
                var changeLine = index === 0?'' : '<hr/>' +'<br/>';
                last = document.getElementsByClassName('section_analyse_content_style')[0].innerHTML + changeLine
                return document.getElementsByClassName('section_analyse_content_style')[0].innerHTML = last.concat(this.searchKeywordHighlight(item,searchText,true))
            });

        } else {
            this.removeContentChild();
            this.setState({
               recover:true,
            });
        }

    };

    //处理分词的点击
    handleFenciAction = (ev,item)=> {
        this.removeContentChild();
        this.scrollLocation = 0;     //滚动条要回到顶部
        this.recoverLastSelectFenciStyle();
        ev.target.style.backgroundColor = '#688CF5';
        ev.target.style.color = 'white';
        this.lastSelectFenci = ev.target;
        this.props.fenciAction(item);
    };

    //分词长度会变，所有底部正文的区域高度也要变化
    handleContentHeight = () => {
        var ele = document.getElementsByClassName('section_analyse_content_fenci_div_style')[0];
        if (ele !== undefined) {
            return 88 - ((ele.clientHeight / (document.body.clientHeight * 0.93)) * 100 + 2)
        }
    };

    //恢复上次点击的分词的样式
    recoverLastSelectFenciStyle = () => {
        if (this.lastSelectFenci !== null && this.lastSelectFenci !== undefined) {
            this.lastSelectFenci.style.backgroundColor = 'white';
            this.lastSelectFenci.style.color = 'black';
        }
    };

    //处理分词模式的两个按钮点击事件
    setFenciMode = (ev,mode) => {
        if (mode === 'start') {
            let lastTag = this.props.fenci.length - 1;
            this.recoverLastSelectFenciStyle()
            var lastFenciBtn = document.getElementById('fenciBtn' + lastTag);
            if (lastFenciBtn !== undefined && lastFenciBtn != null) {   //最后的一个分词
                lastFenciBtn.style.backgroundColor = '#688CF5';
                lastFenciBtn.style.color = 'white';
                this.lastSelectFenci = lastFenciBtn
            }
            
            this.setState({
                startBtnPng: png_start_on,
                haveBtnPng: png_have_off,
          });


            this.fenciMode = 'start';
            if (this.props.fenci.length !== 0) {
                this.currentFenci = this.props.fenci[this.props.fenci.length - 1]
            }
        } else {    
            this.setState({
                    startBtnPng: png_start_off,
                    haveBtnPng: png_have_on,
              });
            console.log('have');
            this.fenciMode = 'have'
        }

        this.props.fenciAction(this.currentFenci);
    };

    getAnalysePageNo = ()=> {
        return this.pageNo;
    };

    recoverPageNo = () => {
        this.pageNo = 1;
    }

    setNextPage = ()=> {
        this.pageNo ++;
    };

    setNoMoreData= ()=> {
        this.hasMore = false;
    };

    handleInfiniteOnLoad = ()=> {
        this.props.loadMoreAnalyse();
    };

    setCurrentFenciStyle = (fenciBtn) => {
        if (fenciBtn != undefined && fenciBtn != null) {
            fenciBtn.style.backgroundColor = Theme_Color;
            fenciBtn.style.color = 'white'
        }
    };

    setCurrentFenci = (fenci)=> {
        this.currentFenci = fenci;

        for (var index = 0; index < this.props.fenci.length; index ++) {
            if (this.props.fenci[index] === fenci) {
                let lastFenciBtn = document.getElementById('fenciBtn' + index);
                this.setCurrentFenciStyle(lastFenciBtn);
                break
            }
        }
    };


    getCurrentFenciMode = () => {
        return this.fenciMode
    };

    render(){
        this.removeLastHight();
        this.removeContentChild();
        let sentence = this.props.arrSententce;
        let displayFenci = this.props.fenci.length === 0?'none':'inline-block';
        return(
            <div className='section_analyse_style'>
                <div className='section_analyse_inner_div_style'>
                    <h4 style={{marginTop : 10 + 'px',color : '#688CF5',textAlign : "center"}}>
                        段落瀑布
                    </h4>
                    <img id={'fenciBtnHave'} onClick={(ev) => {this.setFenciMode(ev,'have')}} className="fenciHaveImg" src={this.state.haveBtnPng}/>
                    <img id={'fenciBtnStart'} onClick={(ev) => {this.setFenciMode(ev,'start')}} className="fenciHaveImg" src={this.state.startBtnPng}/>
                    <Input onPressEnter={this.handleEnterKey}
                           prefix={<Icon type="search" style={{ color: 'rgba(0,0,0,.25)'}} />}
                           style={{marginTop:5 + 'px'}}
                           size='small'
                    />
                    <div className='section_analyse_content_fenci_div_style' style={{display:displayFenci}}>{
                        // this.props.fenci.map((item,index) => {
                        //     return <button id={'fenciBtn' + index} onClick={(ev) => {this.handleFenciAction(ev,item)}} className='section_analyse_fenci_button_style'>{item}</button>
                        // })
                    }
                    </div>
                    <div ref='scroller' onScroll={this.bindScroll} className='section_analyse_content_style'
                            style={{maxHeight:this.handleContentHeight() + '%',height:this.handleContentHeight() + '%'}}> {
                        sentence.map((item, index) => {
                                return  this.keyworkHighLight(item.sentence_content,this.props.suggestWord,index);
                            }
                        )
                    }
                    </div>
                </div>
            </div>
        );
    }
}

export default SectionAPP
